<template>
  <div v-if="globals.isAccessAllowed('LoopOp_KPIs_ReadAll')">
    <!-- This component displays the kpi management  -->

    <!-- ******************* -->
    <!-- *     Toolbar     * -->
    <!-- ******************* -->
    <!-- This is the panel on top of the page where buttons, pagination and searchbar are displayed -->
    <div class="panel panel-default" id="kpi-top-panel">
      <div class="panel-body">
        <div class="col-md-12">
          <!-- Add buttons here  -->
          <button
            class="btn btn-raised btn-top-bar"
            @click="getKpiData()"
            :disabled="!refreshEnabled || disableButtonNoClientSelected()"
          >
            <i class="material-icons md-36">refresh</i>
            <br />
            {{ lang.KM0000 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            @click="openKpiGroupEditModal()"
            :disabled="disableButtonNoClientSelected()"
          >
            <i class="material-icons md-36">group_work</i>
            <br />
            {{ lang.KM0010 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            @click="openEditKpiDialog()"
            :disabled="disableButtonNoClientSelected()"
          >
            <i class="material-icons md-36">add_box</i>
            <br />
            {{ lang.KM0001 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            @click="openKpiAssignmentDialog()"
            :disabled="disableButtonNoClientSelected()"
          >
            <i class="material-icons md-36">assignment</i>
            <br />
            {{ lang.KM0017 }}
          </button>
          <!-- @click="openKpiLanguageDialog()" -->
          <!-- :disabled="selectedKpiGuid == -''|| !globals.isAccessAllowed('LoopOp_KPIsTranslation_Read')" -->
          <button
            class="btn btn-raised btn-top-bar"
            :disabled="disableButtonNoClientSelected()"
            @click="openKpiLanguageDialog()"
          >
            <i class="material-icons md-36">language</i>
            <br />
            {{ lang.KM0009 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            :disabled="!selectedClient"
            @click="showKPICopyModal = true"
          >
            <i class="material-icons md-36">content_copy</i>
            <br />
            {{ lang.KM0021 }}
          </button>
        </div>
      </div>
      <div class="panel-body">
        <div class="col-lg-6">
          <div class="form-group selectbar nopadding">
            <div
              class="select-filter-container"
              style="float: left"
              v-if="
                !feature.isAudiTarget || !feature.isEnabled('audi_importers')
              "
            >
              <select2
                class="form-control"
                v-model="selectedClient"
                ref="clientSelect"
                @change="onClientSelection()"
                :allowClear="true"
                :placeholder="lang.KM0011"
              >
                <option></option>
                <option
                  v-for="client in clientList"
                  :key="client.ClientGuid"
                  :value="client.ClientGuid"
                >
                  {{ client.ClientName }}
                </option>
              </select2>
            </div>
            <div class="select-filter-container" style="float: left" v-else>
              <select2
                class="form-control"
                v-model="selectedImporter"
                ref="importerSelect"
                @change="
                  (selectedKpiGuid = ''), (selectedKpiData = {}), getKpiData()
                "
                :allowClear="true"
                :placeholder="lang.KM0018"
              >
                <option></option>
                <option
                  v-for="importer in importerList"
                  :key="importer.ImporterGuid"
                  :value="importer.ImporterGuid"
                >
                  {{ importer.ImporterName }}
                </option>
              </select2>
            </div>
            <div class="select-filter-container">
              <select2
                class="form-control"
                v-model="selectedProject"
                ref="projectSelect"
                :disabled="clientProjectList.length < 1"
                :allowClear="true"
                :placeholder="lang.KM0012"
                @change="doFiltering()"
              >
                <option></option>
                <option
                  v-for="project in clientProjectList"
                  :key="project.ProjectGuid"
                  :value="project.ProjectGuid"
                >
                  {{ project.ProjectName }}
                </option>
              </select2>
            </div>
          </div>
        </div>
        <div class="col-lg-2">
          <!-- Searchbar - triggered by enter key -->
          <div class="form-group searchbar">
            <input
              type="search"
              class="form-control"
              id="KPIManagementSearchInput"
              :placeholder="lang.KM0002"
              v-model="searchString"
              @keyup.enter="
                (selectedPage = 1),
                  (selectedKpiGuid = ''),
                  (selectedKpiData = {}),
                  doFiltering()
              "
            />
          </div>
        </div>
        <div class="col-lg-4 nopadding">
          <!-- Pagination -->
          <ul class="pagination-fonts pagination btn-group">
            <li>
              <!-- Dropdown: Select the number of elements per page -->
              <a
                role="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                id="elementsPerPageDropdown"
              >
                <i class="material-icons md-18">view_headline</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="elementsPerPageDropdown"
                :delay="globals.tooltipDelay"
                >{{ lang.KM0003 }}</b-tooltip
              >
              <ul class="dropdown-menu">
                <!-- Add dropdown entries here -->
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 20 }"
                    role="button"
                    @click="updatePaging(1, 20)"
                    >20</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 50 }"
                    role="button"
                    @click="updatePaging(1, 50)"
                    >50</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 100 }"
                    role="button"
                    @click="updatePaging(1, 100)"
                    >100</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 200 }"
                    role="button"
                    @click="updatePaging(1, 200)"
                    >200</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 500 }"
                    role="button"
                    @click="updatePaging(1, 500)"
                    >500</a
                  >
                </li>
              </ul>
            </li>

            <!-- Jump to first page -->
            <li
              v-bind:class="{
                disabled: !filteredKpiData.length || selectedPage == 1,
              }"
              @click="updatePaging(1, 0)"
            >
              <a role="button" id="firstPageButton">
                <i class="material-icons md-18">first_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="firstPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.KM0004 }}</b-tooltip
              >
            </li>
            <!-- ... -->
            <li v-if="numberOfPages() > 7 && selectedPage > 4" class="disabled">
              <a role="button">...</a>
            </li>
            <!-- Pagenumbers -->
            <li
              v-for="pageNumber in getVisiblePages()"
              :key="pageNumber"
              v-bind:class="{ active: selectedPage == pageNumber }"
              @click="updatePaging(pageNumber, 0)"
            >
              <a role="button">{{ pageNumber }}</a>
            </li>
            <!-- ... -->
            <li
              v-if="numberOfPages() > 7 && selectedPage < numberOfPages() - 3"
              class="disabled"
            >
              <a role="button">...</a>
            </li>
            <!-- Jump to last page -->
            <li
              v-bind:class="{
                disabled:
                  !filteredKpiData.length || selectedPage == numberOfPages(),
              }"
              @click="updatePaging(numberOfPages(), 0)"
            >
              <a role="button" id="lastPageButton">
                <i class="material-icons md-18">last_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="lastPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.KM0005 }}</b-tooltip
              >
            </li>
            <li class="disabled">
              <a role="button" id="kpisTotalElementsCounter">{{
                filteredKpiData.length
              }}</a>
              <b-tooltip
                ref="tooltip"
                target="kpisTotalElementsCounter"
                :delay="globals.tooltipDelay"
                >{{ lang.KM0020 }}</b-tooltip
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- ******************* -->
    <!-- *      Table      * -->
    <!-- ******************* -->
    <!-- This is the main panel on the page where all data is displayed in a table -->
    <div class="panel panel-default">
      <div class="panel-body">
        <table class="table table-striped table-hover main-table">
          <thead>
            <tr>
              <!-- Add table headers here -->
              <!-- The table sort is triggered by click on the header -->
              <th style="width: 10%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('KPICode')"
                >
                  {{ lang.KM0006 }}
                  <span
                    v-if="showSortArrow('KPICode', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('KPICode', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 10%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('KPIShortText')"
                >
                  {{ lang.KM0007 }}
                  <span
                    v-if="showSortArrow('KPIShortText', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('KPIShortText', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 15%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('KPILongText')"
                >
                  {{ lang.KM0008 }}
                  <span
                    v-if="showSortArrow('KPILongText', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('KPILongText', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 10%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('KPIGroups')"
                >
                  {{ lang.KM0010 }}
                  <span
                    v-if="showSortArrow('KPIGroups', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('KPIGroups', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th
                style="width: 15%"
                class="text-center"
                v-if="
                  !feature.isAudiTarget || !feature.isEnabled('audi_importers')
                "
              >
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('ClientName')"
                >
                  {{ lang.KM0013 }}
                  <span
                    v-if="showSortArrow('ClientName', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('ClientName', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 15%" class="text-center" v-else>
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('Importers')"
                >
                  {{ lang.KM0019 }}
                  <span
                    v-if="showSortArrow('Importers', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('Importers', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 15%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('Projects')"
                >
                  {{ lang.KM0015 }}
                  <span
                    v-if="showSortArrow('Projects', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('Projects', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 10%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('SurveyIdString')"
                >
                  Survey
                  <span
                    v-if="showSortArrow('SurveyIdString', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('SurveyIdString', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 15%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('KPIEvaluationRuleName')"
                >
                  {{ lang.KM0016 }}
                  <span
                    v-if="showSortArrow('KPIEvaluationRuleName', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('KPIEvaluationRuleName', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
            </tr>
            <tr class="table-filters">
              <th class="nopadding" style="width: 10%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.KM0014"
                    v-model="columnFilterObject.KPICode"
                    @keyup.enter="doFiltering(), (selectedPage = 1)"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 10%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.KM0014"
                    v-model="columnFilterObject.KPIShortText"
                    @keyup.enter="doFiltering(), (selectedPage = 1)"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 15%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.KM0014"
                    v-model="columnFilterObject.KPILongText"
                    @keyup.enter="doFiltering(), (selectedPage = 1)"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 10%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.KM0014"
                    v-model="columnFilterObject.KPIGroups"
                    @keyup.enter="doFiltering(), (selectedPage = 1)"
                  />
                </div>
              </th>
              <th
                class="nopadding"
                style="width: 15%"
                v-if="
                  !feature.isAudiTarget || !feature.isEnabled('audi_importers')
                "
              >
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.KM0014"
                    v-model="columnFilterObject.ClientName"
                    @keyup.enter="doFiltering(), (selectedPage = 1)"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 15%" v-else>
                <!-- <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.KM0014"
                    v-model="columnFilterObject.Importers"
                    @keyup.enter="doFiltering(), selectedPage = 1"
                  />
                </div>-->
              </th>
              <th class="nopadding" style="width: 15%">
                <!-- <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.KM0014"
                    v-model="columnFilterObject.Projects"
                    @keyup.enter="doFiltering(), selectedPage = 1"
                  />
                </div>-->
              </th>
              <th class="nopadding" style="width: 10%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.KM0014"
                    v-model="columnFilterObject.SurveyIdString"
                    @keyup.enter="doFiltering(), (selectedPage = 1)"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 15%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    v-model="columnFilterObject.KPIEvaluationRuleName"
                    :placeholder="lang.KM0014"
                    @keyup.enter="doFiltering(), (selectedPage = 1)"
                  />
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="main-table-scrollbar">
            <tr
              role="button"
              v-for="kpi in kpiDataOnCurrentPage"
              :key="kpi.KPIGuid"
              @click="(selectedKpiGuid = kpi.KPIGuid), (selectedKpiData = kpi)"
              @dblclick="openKpiAssignmentDialog()"
              :class="{ info: kpi.KPIGuid === selectedKpiGuid }"
            >
              <!-- Add table data here -->
              <td style="width: 10%">{{ kpi.KPICode }}</td>
              <td style="width: 10%">{{ kpi.KPIShortText }}</td>
              <td style="width: 15%">{{ kpi.KPILongText }}</td>
              <td style="width: 10%">{{ kpi.KPIGroups[0].KPIGroupCode }}</td>
              <td
                style="width: 15%"
                v-if="
                  !feature.isAudiTarget || !feature.isEnabled('audi_importers')
                "
              >
                {{ kpi.ClientName }}
              </td>
              <td style="width: 15%" v-else>
                {{ kpi.Importers ? kpi.Importers[0].ImporterName : "" }}
              </td>
              <td style="width: 15%">{{ kpi.Projects[0].ProjectName }}</td>
              <td style="width: 10%">{{ kpi.SurveyIdString }}</td>
              <td style="width: 15%">{{ kpi.KPIEvaluationRuleName }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ******************* -->
    <!-- *      Modal      * -->
    <!-- ******************* -->
    <kpi-group-edit-modal
      :showDialog="showKpiGroupEditDialog"
      :clientList="clientList"
      :projectList="projectList"
      :kpiGroupEvaluationRulesList="kpiGroupEvaluationRulesList"
      :selectedClientForKpiGroups="selectedClient"
      @dialogClosed="onKpiGroupEditDialogClosed"
    ></kpi-group-edit-modal>

    <kpi-management-edit-modal
      :showDialog="showEditKpiDialog"
      :clientList="clientList"
      :selectedClientForKpi="selectedClient"
      :projectList="projectList"
      :kpiEvaluationRulesList="kpiEvaluationRulesList"
      @dialogClosed="onEditKpiDialogClosed"
    ></kpi-management-edit-modal>

    <kpi-assignment-modal
      :showDialog="showKpiAssignmentDialog"
      :clientList="clientList"
      :projectList="projectList"
      :selectedClientFromParent="selectedClient"
      :selectedKpiData="selectedKpiData"
      :kpiEvaluationRulesList="kpiEvaluationRulesList"
      :kpiGroupEvaluationRulesList="kpiGroupEvaluationRulesList"
      @dialogClosed="onKpiAssignmentDialogDialogClosed"
    ></kpi-assignment-modal>

    <kpi-management-translate-modal
      :showDialog="showTranslateKpiDialog"
      :client="selectedClientForKpiTranslation"
      :projects="clientProjectList"
      :initialProject="selectedProject"
      @dialogClosed="onTranslateKpiDialogClosed"
    ></kpi-management-translate-modal>

    <KPICopyModal
      :showModal="showKPICopyModal"
      :projects="clientProjectList"
      :selectedProject="selectedProject"
      @copyDone="getKpiData()"
      @modalClosed="showKPICopyModal = false"
    ></KPICopyModal>
  </div>
</template>

<script>
import KPIManagementEditModal from "./KPIManagementEditModal";
import KPIManagementTranslateModal from "./KPIManagementTranslateModal";
import KPIGroupEditModal from "./KPIGroupEditModal.vue";
import KPIAssignmentModal from "./KPIAssignmentModal.vue";
import KPICopyModal from "./KPICopyModal";
import Select2 from "../Tools/Select2";

export default {
  name: "KPIManagement",
  components: {
    "kpi-group-edit-modal": KPIGroupEditModal,
    "kpi-management-edit-modal": KPIManagementEditModal,
    "kpi-assignment-modal": KPIAssignmentModal,
    "kpi-management-translate-modal": KPIManagementTranslateModal,
    KPICopyModal,
    Select2,
  },
  data() {
    return {
      showEditKpiDialog: false,
      showTranslateKpiDialog: false,
      showKpiGroupEditDialog: false,
      showKpiAssignmentDialog: false,
      showKPICopyModal: false,
      clientList: [],
      importerList: [],
      projectList: [],
      clientProjectList: [],
      filteredKpiData: [],
      kpiDataOnCurrentPage: [],
      refreshEnabled: false, // false, if kpi data is requested and server did not respond yet to avoid multiple requests at the same time
      kpiData: [], // List of all kpis
      selectedKpiGuid: "", // GUID of the selected kpi
      selectedKpiData: {},
      searchString: "",
      pageSize: 20, // Number of kpis on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      selectedClient: "",
      selectedImporter: "",
      selectedProject: "",
      clientInformation: {},
      kpiGroupEvaluationRulesList: [],
      kpiEvaluationRulesList: [],
      columnFilterObject: {
        KPICode: "",
        KPIShortText: "",
        KPILongText: "",
        KPIGroups: "",
        ClientName: "",
        Importers: "",
        Projects: "",
        SurveyIdString: "",
        KPIEvaluationRuleName: "",
      },
      currentSort: { key: "KPICode", asc: true },
      selectedClientForKpiTranslation: {},
      lang: {
        // Contains localization strings for the selected language
        KM0000: "Refresh",
        KM0001: "KPI Management",
        KM0002: "Search...",
        KM0003: "Items per page",
        KM0004: "First page",
        KM0005: "Last page",
        KM0006: "KPI Code",
        KM0007: "KPI Shorttext",
        KM0008: "KPI Longtext",
        KM0009: "Translation",
        KM0010: "KPI Groups",
        KM0011: "Please select a client...",
        KM0012: "Please select a project...",
        KM0013: "Client",
        KM0014: "Filter",
        KM0015: "Project",
        KM0016: "Calculation rule",
        KM0017: "Assignment",
        KM0018: "Please select an importer...",
        KM0019: "Importer",
        KM0020: "Total KPIs count",
        KM0021: "Copy KPI data",
      },
    };
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    this.readComponentSettingsFromStore();
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    this.getKpiGroupEvaluationRulesList();
    this.getKpiEvaluationRulesList();
    this.globals.getClientList((data) => {
      this.clientList = data;
      if (
        this.feature.isAudiTarget &&
        this.feature.isEnabled("audi_importers") &&
        this.clientList[0]
      ) {
        this.selectedClient = this.clientList[0].ClientGuid;
        this.onClientSelection();
      }
      this.$emit("ClientListReceived");
    });
    this.globals.getProjectList((data) => {
      this.projectList = data;
      if (this.selectedClient) this.getClientProjectList();
      this.$emit("ProjectListReceived");
    });

    if (this.feature.isAudiTarget && this.feature.isEnabled("audi_importers")) {
      this.globals.getImporterList((data) => {
        this.importerList = data;
      });
    }

    $(window).on("resize", this.setTableHeight).resize();

    if (!this.globals.currentUserInfo)
      this.globals.$once("currentUserInfoReceived", this.setTableHeight);
  },
  destroyed() {
    $(window).off("resize", this.setTableHeight);
    this.writeComponentSettingsToStore();
  },
  methods: {
    setTableHeight() {
      this.$nextTick(() => {
        let height = $(window).height();
        height -=
          $("#kpi-top-panel").height() +
          $("#app-navbar").height() +
          $(".main-table > thead").height() +
          47;
        $(".main-table-scrollbar").css("max-height", height);
      });
    },
    readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;

      this.$filterRestorePending = true;
      let restoreDone = () => {
        if (this.$refs.clientSelect) this.$refs.clientSelect.updateValue();
        if (this.$refs.importerSelect) this.$refs.importerSelect.updateValue();
        if (this.$refs.projectSelect) this.$refs.projectSelect.updateValue();

        delete this.$filterRestorePending;
        this.getKpiData();
      };
      let restoreFilters = () => {
        this.$nextTick(() => {
          let storedData = this.$store.getters["localFilters/kpiManagement"];
          if (storedData) {
            for (let key in storedData) {
              if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
              if (key === "selectedClient") this.onClientSelection();
            }
          }

          if (!this.$store.getters["userSettings/syncFilters"]) {
            restoreDone();
            return;
          }
          if (
            !this.feature.isAudiTarget ||
            !this.feature.isEnabled("audi_importers")
          ) {
            let storedClient = this.$store.getters["sharedFilters/client"];
            this.selectedClient = storedClient.ClientGuid || "";
            this.onClientSelection();
          } else {
            let storedImporter = this.$store.getters["sharedFilters/importer"];
            this.selectedImporter = storedImporter.ImporterGuid || "";
          }

          let storedProject = this.$store.getters["sharedFilters/project"];
          this.selectedProject = storedProject.ProjectGuid || "";

          restoreDone();
        });
      };
      this.globals.doAfterEvents(
        ["ClientListReceived", "ProjectListReceived"],
        restoreFilters,
        this
      );
    },
    writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/kpiManagement", {
        selectedClient: this.selectedClient,
        selectedImporter: this.selectedImporter,
        selectedProject: this.selectedProject,
        columnFilterObject: this.columnFilterObject,
        searchString: this.searchString,
        currentSort: this.currentSort,
        pageSize: this.pageSize,
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (
        !this.feature.isAudiTarget ||
        !this.feature.isEnabled("audi_importers")
      ) {
        if (this.selectedClient) {
          let client = _.find(this.clientList, (c) => {
            return c.ClientGuid === this.selectedClient;
          });
          if (client) this.$store.commit("sharedFilters/client", client);
        } else {
          let storedClient = this.$store.getters["sharedFilters/client"];
          if (storedClient.ClientGuid)
            this.$store.commit("sharedFilters/client");
        }
      } else {
        if (this.selectedImporter) {
          let importer = _.find(this.importerList, (i) => {
            return i.ImporterGuid === this.selectedImporter;
          });
          if (importer) this.$store.commit("sharedFilters/importer", importer);
        } else {
          let storedImporter = this.$store.getters["sharedFilters/importer"];
          if (storedImporter.ImporterGuid)
            this.$store.commit("sharedFilters/importer");
        }
      }

      if (this.selectedProject) {
        let project = _.find(this.clientProjectList, (p) => {
          return p.ProjectGuid === this.selectedProject;
        });
        if (project) this.$store.commit("sharedFilters/project", project);
      } else {
        let storedProject = this.$store.getters["sharedFilters/project"];
        if (storedProject.ProjectGuid)
          this.$store.commit("sharedFilters/project");
      }
    },
    onClientSelection() {
      this.selectedKpiGuid = "";
      this.selectedKpiData = {};
      this.getKpiData();
      this.getClientProjectList();
      this.getClientInformation();
    },
    disableButtonNoClientSelected() {
      return !this.selectedClient;
    },
    getClientInformation() {
      if (this.selectedClient)
        this.clientInformation = this.clientList.find(
          (client) => client.ClientGuid === this.selectedClient
        );
    },
    // Select Customer Project
    getClientProjectList() {
      this.selectedProject = "";
      this.clientProjectList = [];
      if (this.selectedClient) {
        let listOfClientProjects = this.projectList.filter(
          (project) => project.ClientGuid === this.selectedClient
        );
        if (listOfClientProjects.length > 0) {
          this.clientProjectList = listOfClientProjects[0].Projects;
          this.sortClientProjectList();
        }
      }
    },
    sortClientProjectList() {
      this.clientProjectList.sort((a, b) => {
        // Sort projects by name
        if (a.ProjectName.toLowerCase() < b.ProjectName.toLowerCase())
          return -1;
        if (a.ProjectName.toLowerCase() > b.ProjectName.toLowerCase()) return 1;
        return 0;
      });
    },
    getKpiData() {
      if (this.$filterRestorePending) return;
      if (!this.selectedClient) {
        this.kpiData = [];
        this.doFiltering();
        return;
      }
      this.refreshEnabled = false;
      let queryString = `api/KPIs/Client/${this.selectedClient}`;

      if (this.selectedImporter)
        queryString += `?ImporterGuid=${this.selectedImporter}`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.kpiData = !_.isEmpty(data) ? data : [];
          for (let kpi of this.kpiData) {
            kpi.SurveyIdString = this.getSurveyIdListString(kpi.Surveys);
          }
          this.doFiltering();
        },
        error: () => {
          console.error("KPI data request failed in getKpiData()");
          this.globals.showErrorSnackbar("KPI data access failed");
        },
        complete: () => {
          this.refreshEnabled = true;
        },
      });
    },
    getKpiGroupEvaluationRulesList() {
      let queryString = "api/KPIGroups/Data/EvaluationRules";

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.kpiGroupEvaluationRulesList = [];
          Object.entries(data).forEach(([key, value]) =>
            this.kpiGroupEvaluationRulesList.push({
              EvaluationRuleGuid: key,
              EvaluationRule: value,
            })
          );
        },
        error: () => {
          console.error(
            "KPI group evaluation rules access failed in getKpiGroupEvaluationRulesList()"
          );
          this.globals.showErrorSnackbar("Evaluation rules access failed");
        },
      });
    },
    getKpiEvaluationRulesList() {
      let queryString = "api/KPIs/Data/EvaluationRules";

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.kpiEvaluationRulesList = [];
          Object.entries(data).forEach(([key, value]) =>
            this.kpiEvaluationRulesList.push({
              EvaluationRuleGuid: key,
              EvaluationRule: value,
            })
          );
        },
        error: () => {
          console.error(
            "KPI evaluation rules access failed in getKpiEvaluationRulesList()"
          );
          this.globals.showErrorSnackbar("Evaluation rules access failed");
        },
      });
    },
    getSurveyIdListString(surveys) {
      if (!surveys || !surveys.length) return "";
      let result = "";
      for (let i = 0; i < surveys.length; i++) {
        result += surveys[i].SurveyId;
        if (i < surveys.length - 1) result += ", ";
      }
      return result;
    },
    showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    orderTableByColumn(orderProp) {
      // Nothing to sort by => return
      if (!orderProp && !this.currentSort.key) return;

      if (orderProp) {
        this.currentSort.key === orderProp
          ? (this.currentSort.asc = !this.currentSort.asc)
          : (this.currentSort = { asc: true, key: orderProp });
      }

      const sortFunction = (kpi) => {
        if (typeof kpi[this.currentSort.key] === "string") {
          return kpi[this.currentSort.key].toLowerCase();
        } else if (Array.isArray(kpi[this.currentSort.key])) {
          if (kpi[this.currentSort.key][0].KPIGroupCode)
            return kpi[this.currentSort.key][0].KPIGroupCode.toLowerCase();
          if (kpi[this.currentSort.key][0].ProjectName)
            return kpi[this.currentSort.key][0].ProjectName.toLowerCase();
          if (kpi[this.currentSort.key][0].ImporterName)
            return kpi[this.currentSort.key][0].ImporterName.toLowerCase();
        }
        return kpi[this.currentSort.key];
      };
      this.filteredKpiData = _.orderBy(
        this.filteredKpiData,
        [sortFunction],
        [this.currentSort.asc ? "asc" : "desc", "asc"]
      );
      this.loadCurrentPageOfKpiData();
    },
    doFiltering() {
      // Reset filtering when search string is empty
      if (!this.searchString) this.filteredKpiData = this.kpiData;

      let words = this.searchString.split(" ");
      let keys = [
        "KPICode",
        "KPIShortText",
        "KPILongText",
        "KPIGroups",
        "ClientName",
        "Importers",
        "Projects",
        "SurveyIdString",
        "KPIEvaluationRuleName",
      ];

      let filterStrings = this.columnFilterObject;

      const kpiFilter = (kpi) => {
        let containsSearch = false;
        words.forEach((word) => {
          keys.forEach((key) => {
            if (key === "KPIGroups") {
              if (
                kpi[key][0] &&
                kpi[key][0].KPIGroupCode &&
                kpi[key][0].KPIGroupCode.toString()
                  .toLowerCase()
                  .indexOf(word.toLowerCase()) > -1
              ) {
                containsSearch = true;
                return;
              }
            } else if (key === "Projects") {
              if (
                kpi[key][0] &&
                kpi[key][0].ProjectName &&
                kpi[key][0].ProjectName.toString()
                  .toLowerCase()
                  .indexOf(word.toLowerCase()) > -1
              ) {
                containsSearch = true;
                return;
              }
            } else if (key === "Importers") {
              if (
                kpi[key] &&
                kpi[key][0].ImporterName.toString()
                  .toLowerCase()
                  .indexOf(word.toLowerCase()) > -1
              ) {
                containsSearch = true;
                return;
              }
            } else if (
              kpi[key] &&
              kpi[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1
            ) {
              containsSearch = true;
              return;
            }
          });
        });
        if (!containsSearch) return false; // KPI does not match search string

        keys.forEach((key) => {
          if (!containsSearch) return;

          if (key === "KPIGroups") {
            if (
              kpi[key][0] &&
              kpi[key][0].KPIGroupCode &&
              kpi[key][0].KPIGroupCode.toString()
                .toLowerCase()
                .indexOf(filterStrings[key].toLowerCase()) < 0
            ) {
              containsSearch = false;
              return;
            }
          } else if (key === "Projects") {
            if (
              kpi[key][0] &&
              kpi[key][0].ProjectName &&
              kpi[key][0].ProjectName.toString()
                .toLowerCase()
                .indexOf(filterStrings[key].toLowerCase()) < 0
            ) {
              containsSearch = false;
              return;
            }
          } else if (key === "Importers") {
            if (
              (!kpi[key] && filterStrings[key]) ||
              (kpi[key] &&
                kpi[key][0].ImporterName.toString()
                  .toLowerCase()
                  .indexOf(filterStrings[key].toLowerCase()) < 0)
            ) {
              containsSearch = false;
              return;
            }
          } else if (
            (!kpi[key] && filterStrings[key]) ||
            (kpi[key] &&
              kpi[key]
                .toString()
                .toLowerCase()
                .indexOf(filterStrings[key].toLowerCase()) < 0)
          ) {
            containsSearch = false; // KPI does not match filterstring
            return;
          }
        });
        return containsSearch;
      };

      this.filteredKpiData = !_.isEmpty(this.kpiData)
        ? this.kpiData.filter(kpiFilter)
        : [];

      // Filter kpi data for selected project
      if (this.selectedProject) {
        this.filteredKpiData = this.filteredKpiData.filter(
          (kpi) => kpi.Projects[0].ProjectGuid === this.selectedProject
        );
      }

      this.currentSort.asc = !this.currentSort.asc;
      this.orderTableByColumn(this.currentSort.key);
    },
    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages() {
      if (this.numberOfPages() <= 7) {
        return _.range(1, this.numberOfPages() + 1);
      } else if (this.numberOfPages() > 7 && this.selectedPage <= 4) {
        return _.range(1, 7);
      } else if (
        this.numberOfPages() > 7 &&
        this.selectedPage >= this.numberOfPages() - 3
      ) {
        return _.range(this.numberOfPages() - 5, this.numberOfPages() + 1);
      } else {
        return _.range(this.selectedPage - 2, this.selectedPage + 3);
      }
    },
    updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber;
      if (pageSize != 0) this.pageSize = pageSize;
      this.loadCurrentPageOfKpiData();
    },
    // Returns the count of pages depending on the selected pagesize and the length of the client data list
    numberOfPages() {
      if (this.pageSize == -1) return 1;
      if (this.filteredKpiData.length % this.pageSize == 0)
        return this.filteredKpiData.length / this.pageSize;
      else return parseInt(this.filteredKpiData.length / this.pageSize) + 1;
    },
    loadCurrentPageOfKpiData() {
      if (this.pageSize == -1) this.kpiDataOnCurrentPage = this.filteredKpiData;
      else {
        // Display all data, no pages
        this.kpiDataOnCurrentPage = [];
        var startIndex = (this.selectedPage - 1) * this.pageSize;
        for (var i = startIndex; i < startIndex + this.pageSize; i++) {
          if (this.filteredKpiData[i] != null)
            this.kpiDataOnCurrentPage[i - startIndex] = this.filteredKpiData[i];
        }
      }
    },
    openEditKpiDialog() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_ReadAll")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_ReadAll");
        return;
      }
      this.showEditKpiDialog = true;
    },
    onEditKpiDialogClosed() {
      this.showEditKpiDialog = false;
      this.getKpiData();
    },
    getSelectedClient(clientGuid) {
      let client = this.clientList.find(
        (client) => client.ClientGuid === clientGuid
      );
      return { clientGuid: client.ClientGuid, clientName: client.ClientName };
    },
    // Opens the dialog to translate kpis
    openKpiLanguageDialog() {
      this.selectedClientForKpiTranslation = this.getSelectedClient(
        this.selectedClient
      );
      this.showTranslateKpiDialog = true;
    },
    // Gets executed after the translateKpiDialog got closed
    onTranslateKpiDialogClosed() {
      this.showTranslateKpiDialog = false;
    },
    openEditKpiDataDialog() {
      this.showEditKpiDialog = true;
    },
    openKpiGroupEditModal() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_ReadAll")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_ReadAll");
        return;
      }
      this.showKpiGroupEditDialog = true;
    },
    onKpiGroupEditDialogClosed() {
      this.showKpiGroupEditDialog = false;
      this.getKpiData();
    },
    openKpiAssignmentDialog() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIsAssignment_Read")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIsAssignment_Read");
        return;
      }
      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_ReadAll")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_ReadAll");
        return;
      }
      this.showKpiAssignmentDialog = true;
    },
    onKpiAssignmentDialogDialogClosed() {
      this.showKpiAssignmentDialog = false;
      this.getKpiData();
    },
  },
};
</script>

<style scoped>
.select-filter-container {
  width: 50%;
  display: inline-block;
  padding-right: 10px;
  margin: 9px 0 3px 0;
}
</style>



// WEBPACK FOOTER //
// KPIManagement.vue?8d2ffdf0